import React, { createElement, useEffect } from 'react';
import './index.scss';
import { default as MessageListItem } from './message-list-item';
import { convertChildren } from '../../utils/children-node-handle';
const MessageList = ({ dataList, handleDataList, onClick = () => { }, children, images, ...otherProps }) => {
    const _otherProps = otherProps || {};
    const [currentDataList, setCurrentDataList] = React.useState(dataList || []);
    const handleClick = (key) => {
        handleDataList(key);
    };
    images = images || [];
    useEffect(() => {
        setCurrentDataList(dataList || []);
    }, [dataList]);
    return (createElement("div", { className: "message-list__panel", ..._otherProps },
        createElement("div", { className: "message-list__panel__tab" }, convertChildren(children, 'tabMessage', { onClickHandle: handleClick })),
        createElement("div", { className: "message-list__panel__item-list" }, currentDataList ? (currentDataList.map((item, index) => {
            return (createElement(MessageListItem, { key: index, onClick: onClick, ...item, image: images[index % images.length] }, children));
        })) : (createElement("div", null, "\u6682\u65E0\u6570\u636E")))));
};
MessageList.displayName = 'MessageList';
export default MessageList;
